import { Typography } from '@mui/material';

import Number from 'src/components/common/Number';
import { ETHERSCAN_URL } from 'src/constants/explorer';
import { WETH_DYDX_TOKEN_ADDRESS } from 'src/constants/tokens';
import { fix, gt } from 'src/utils/number';
import { shortAddress } from 'src/utils/string';

import { AmountContainer, Base02TextContainer, Container, InfoBodyContainer, InfoTextContainer, TitleContainer, URLButton } from './styled';

type TxDetailsProps = {
  estimatedGasFee: string;
};

export default function TxDetails({ estimatedGasFee }: TxDetailsProps) {
  const shortContractAddress = shortAddress(WETH_DYDX_TOKEN_ADDRESS, 10);

  return (
    <Container>
      <>
        <TitleContainer>
          <Typography variant="h3">Details</Typography>
        </TitleContainer>
        <InfoBodyContainer>
          <InfoTextContainer>
            <Base02TextContainer>
              <Typography variant="h7">DYDX Bridge Contract</Typography>
            </Base02TextContainer>

            <URLButton type="button" onClick={() => window.open(`${ETHERSCAN_URL}/address/${WETH_DYDX_TOKEN_ADDRESS}` || '')}>
              <Typography variant="h6">{shortContractAddress || '-'}</Typography>
            </URLButton>
          </InfoTextContainer>
          <InfoTextContainer>
            <Base02TextContainer>
              <Typography variant="h7">Estimated Gas Fee</Typography>
            </Base02TextContainer>
            {gt(estimatedGasFee, '0') ? (
              <AmountContainer>
                <Typography variant="h6">~</Typography>
                &nbsp;
                <Number typoOfIntegers="h6" typoOfDecimals="h9">
                  {String(parseFloat(fix(estimatedGasFee, 8)))}
                </Number>
                &nbsp;
                <Typography variant="h6">ETH</Typography>
              </AmountContainer>
            ) : (
              <Typography variant="h6">-</Typography>
            )}
          </InfoTextContainer>
        </InfoBodyContainer>
      </>
    </Container>
  );
}
